/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Card_DeleteInputs */



/**
* | output |
* | --- |
* | "Removed a card" |
*
* @param {Activity_Card_DeleteInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const activity_card_delete = /** @type {((inputs?: Activity_Card_DeleteInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Card_DeleteInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Карта удалена")
	return /** @type {LocalizedString} */ ("Removed a card")
});